// extracted by mini-css-extract-plugin
export default {"input":"input_input__GoHXb","lebel":"input_lebel__sAIaC"};